import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import { ErrorState } from '~/components'
import { workspaceHandleAvailableQueryOptions, workspacesQueryOptions } from '../queries'

export const Route = createFileRoute('/$')({
  beforeLoad: async ({ context, params }) => {
    const { _splat: maybeWorkspaceHandle } = params
    const { usedBy: workspaceId } = await context.queryClient.ensureQueryData(
      workspaceHandleAvailableQueryOptions(maybeWorkspaceHandle ?? '')
    )
    if (!workspaceId) {
      return
    }

    const workspaces = await context.queryClient.ensureQueryData(workspacesQueryOptions())

    const userIsMember = workspaces.some((w) => w.id === workspaceId)
    if (userIsMember) {
      throw redirect({
        to: `/workspaces/${workspaceId}/home` as any,
        mask: { to: `/${maybeWorkspaceHandle}` as any, unmaskOnReload: false },
        params: { workspaceId } as any,
      })
    }

    return
  },
  component: () => {
    const navigate = useNavigate()
    return (
      <ErrorState
        title="Not Found"
        description="Sorry, we could not find the page you were looking for."
        navigateToHome={() => {
          void navigate({ to: '/' })
        }}
      />
    )
  },
})
